import { Observable } from 'rxjs';
import { Action } from 'redux';
import { ofType, StateObservable } from 'redux-observable';
import AppState from '../../state';
import { withLatestFrom, mergeMap } from 'rxjs/operators';
import * as artists from '@webapp/sdk/artists';
import { ADD_ARTIST_TO_RELEASE } from '../actions';
import { AddArtistToRelease } from '../action-creators';
import { UpdateField, UpdateReleaseError } from '../action-creators';
import { NoOp } from '@webapp/store/ui/action-creators';

export const addArtistToReleaseEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, AddArtistToRelease>(ADD_ARTIST_TO_RELEASE),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      try {
        const artist = await artists.inviteArtist({
          name: action.name,
          externalProfile: action.externalArtist,
        });

        if (state.release.release?.artists?.some((a) => a.id === artist.id)) {
          return new NoOp();
        }

        return new UpdateField<'artists'>(
          'artists',
          (state.release.release?.artists || []).concat({
            ...artist,
            role: 'main',
          })
        );
      } catch (err) {
        return new UpdateReleaseError((err as Error).message);
      }
    })
  );
